import React, { Component } from "react";
import StatsBox from "../StatsPage/StatsBox.js";
import InfoTable from "../InfoTable.js";
import ResultInfoText from "../ResultsTable/ResultInfoText.js";
import KingdomIcon from "../ReactionTable/kingdomIcon.js";

import { useState, useEffect } from "react";
import axios from "../../api/axios.js";
import getDataByEnzymesFromSearchResults from "../../api/transformSearchResultsToEnzymes.js";
import { useParams } from "react-router-dom";
import ReactionResultBox from "../ResultsTable/ReactionResultBox.js";
import SmallLoading from "../smallLoading.js";
import MoleculesDiv from "../MoleculeTable/MoleculesDiv.js";
import { getUniqueMoleculesFromEnzymesAllInfo, hasUnresolvedMolecule } from "../../api/HelperFunctions.js";
import MechanismViewer from "../MechanismView/mechanismViewer.js";
import { groupKingdoms, groupTypesAndKingdoms } from "../../functions/statisticsDataProcessing.js";
import translateTerpeneType from "../../api/typeTranslator.js";
import MoleculeForm from "../SubmitPage/MoleculeForm.js";
import SubmitInputField from "../SubmitPage/submitInputField.js";


function MechanismBrowser({searchResult, setMechBody, navigateToRecord}) {
  const [stats, setStats] = useState(null);
  const [kingdoms, setKingdoms] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedKingdoms, setSelectedKingdoms] = useState([]);
  const [selectedMolecules, setSelectedMolecules] = useState([{ molecule_id: null, smiles: "", name: "", marts: "", chebi: "" }]);
  const [selectedMoleculeName, setSelectedMoleculeName] = useState("");
  const [searchData, setSearchData] = useState({ types: [], classes: [], kingdoms: [], getMechanismsOfSubstratesAndProducts: true, species: [], moleculeNameLike: "" });
  const [selectedSpecies, setSelectedSpecies] = useState([]);
  const [noResults, setNoResults] = useState(false);

    function processStats(stats){
    let kingdomsNames = stats.kingdomsCounts.map(k => k.kingdom);
    const typesAndKingdoms = groupTypesAndKingdoms(stats.terpeneTypesByKingdomCount);
    stats.groupedTypesKingdoms = typesAndKingdoms[0];
    setKingdoms(kingdomsNames.sort());
    return stats;
  }

  useEffect(() => {
    axios.post("/statspage").then(res => {
      setStats(processStats(res.data));
    });
  }, []);

  const toggleSelection = (value, selectedValues, setSelectedValues) => {
    if (selectedValues.includes(value)) {
      setSelectedValues(selectedValues.filter(v => v !== value));
    } else {
      setSelectedValues([...selectedValues, value]);
    }
  };

  const handleSearch = () => {
    // A molecule row with a typed identifier that never resolved to a MARTS
    // molecule cannot match anything: show an empty network instead of firing a
    // search that would drop the filter and return every mechanism.
    if (hasUnresolvedMolecule(selectedMolecules)) {
      setNoResults(true);
      return;
    }
    setNoResults(false);
    setSearchData({
      types: selectedTypes,
      classes: selectedClasses,
      kingdoms: selectedKingdoms,
      molecules: selectedMolecules.map(mol => mol.marts).filter(marts => marts != ""),
      species: selectedSpecies,
      moleculeNameLike: selectedMoleculeName,
      getMechanismsOfSubstratesAndProducts: true
    });
  };

  const addMolecule = () => {
    setSelectedMolecules([...selectedMolecules, { molecule_id: null, smiles: "", name: "", marts: "", chebi: "" }]);
  };

  const removeLastMolecule = () => {
    setSelectedMolecules(selectedMolecules.slice(0, -1));
  };

       const handleSpeciesChange = (e) => {
        const value = e.target.value;
        setSelectedSpecies([value]);
    }

  const clearSearch = () => {
    setSelectedTypes([]);
    setSelectedClasses([]);
    setSelectedKingdoms([]);
    setSelectedMolecules([{ molecule_id: null, smiles: "", name: "", marts: "", chebi: "" }]);
    setSelectedMoleculeName("");
    setSelectedSpecies([]);
    setNoResults(false);
    setSearchData({ types: [], classes: [], kingdoms: [], getMechanismsOfSubstratesAndProducts: true, species: [], moleculeNameLike: "" });
  };

  if (!stats) return <StatsBox title="Loading mechanisms..."><SmallLoading /></StatsBox>;

  return (
    <>
      <StatsBox title="Mechanism filters" hide={true}>
          <StatsBox title="Terpene types">
            <div className="checkboxes-div">
            {stats.terpenesByType.map(t => (
              <label key={t.type} className="basic-checkbox">
                <input
                  type="checkbox"
                  className="basic-checkbox-box"
                  checked={selectedTypes.includes(t.type)}
                  onChange={() => toggleSelection(t.type, selectedTypes, setSelectedTypes)}
                />
                <span >{translateTerpeneType(t.type)}</span>
              </label>          
            ))}
            </div>
          </StatsBox>

          <StatsBox title="Reaction classes">
            <div className="checkboxes-div">
            {[1, 2].map(cls => (
              <label key={cls} className="basic-checkbox">
                <input
                  type="checkbox"
                  className="basic-checkbox-box"
                  checked={selectedClasses.includes(cls)}
                  onChange={() => toggleSelection(cls, selectedClasses, setSelectedClasses)}
                />
                <span>Class {cls == 1 ? "I" : "II"}</span>
              </label>
            ))}
            </div>
          </StatsBox>

          <StatsBox title="Kingdoms">
            <div className="checkboxes-div">
            {kingdoms.map(k => (
              <label key={k} className="basic-checkbox">
                <input
                  type="checkbox"
                  className="basic-checkbox-box"
                  checked={selectedKingdoms.includes(k)}
                  onChange={() => toggleSelection(k, selectedKingdoms, setSelectedKingdoms)}
                />
                <span>{k}</span>
              </label>
            ))}
           </div> 
          </StatsBox>

            <StatsBox title="Origin species">
            <div>
              <SubmitInputField name="nameSpecies" value={selectedSpecies} onChange={handleSpeciesChange} label="Species name" disabled={false} tooltip={"Enter part of the desired species name"} placeholder="Arabidopsis thaliana"/>
            </div>
            </StatsBox>

          <StatsBox title="Molecules">
            <p>Molecular structures that appear in the mechanism. Molecules are searched by marts, when other fields are filled, MARTS will be filled in automatically. Alternatively you can search by matching part of molecule name.</p>
            <SubmitInputField
              name="moleculeNameLike"
              value={selectedMoleculeName}
              onChange={(e) => setSelectedMoleculeName(e.target.value)}
              label="Molecule name (fuzzy)"
              disabled={false}
              tooltip="Find mechanisms containing any molecule whose name matches this substring. Combined with the molecules below using OR."
              placeholder="e.g. germacrene"
            />
            {selectedMolecules.map((mol, index) => (
              <MoleculeForm key={index}
              title_text={`Molecule`}
              molecule={mol}
              onChange={(updatedMolecule) =>  setSelectedMolecules(selectedMolecules.map((s, i) => (i === index ? updatedMolecule : s)))}
              disabled={false}
            moleculeId_start={mol.molecule_id}
            tooltips={{smiles: "Enter the SMILES of the desired molecule. If a molecule described by this SMILES exists in the database, MARTS ID will be filled in.", name: "Enter the name of the molecule as saved in MARTS. If it exists MARTS ID will be filled.", chebi: "Enter the ID of the molecule in ChEBI database. If it exists in the databse MARTS ID will be filled.",
              marts: "Enter the MARTS ID, the molecule will be searched based on MARTS."
            }}/>
            ))
            }
            <button className="basic-button" onClick={addMolecule}>Add molecule</button>
            <button className="basic-button" onClick={removeLastMolecule} >Remove molecule</button>
          </StatsBox>

          <button
            className="basic-button"
            onClick={handleSearch}
          >
            Display selected
          </button>
      </StatsBox>

      <StatsBox title="Mechanism Network">
        {noResults
          ? <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>No mechanisms match the entered molecule.</div>
          : <MechanismViewer searchData={searchData} orientation="LR" height="1000px"/>}
      </StatsBox>
    </>
  );
}

export default MechanismBrowser;